<template>
  <div>
    <div class="home">
      <landingHeader />
      <landingSplash />
    </div>
    <landingAbout />
    <!-- <landingFaqs /> -->
    <!-- <landingDownload /> -->
    <landingFooter />
  </div>
</template>

<script>
// import { routerAsync } from '@/app-module';
import landingHeader from '@/modules/saryahLanding/components/landing-header-new.vue';
import landingSplash from '@/modules/saryahLanding/components/home-splash.vue';
// import landingDownload from '@/modules/saryahLanding/components/download-app.vue';
// import landingFaqs from '@/modules/saryahLanding/components/faqs.vue';

import landingAbout from '@/modules/saryahLanding/components/landing-about-new.vue';
// import landingTourApp from '@/modules/saryahLanding/components/landing-mobileApp.vue';
import landingFooter from '@/modules/saryahLanding/components/landing-footer.vue';
// import loading from '@/modules/saryahLanding/components/landing-splash.vue';
import { mapGetters, mapActions } from 'vuex';
import i18n from '@/vueI18n';

// import { i18n } from '@/i18n';

import meta from '@/utils/meta.js';

export default {
  name: 'app-landing-layout',

  // metaInfo: {
  //   title: i18n('metaTitle.mainTitle'),
  //   meta: [
  //     {
  //       key: 'og:title',
  //       // name: 'og:title',
  //       property: 'og:title',
  //       content: i18n('meta.title'),
  //     },
  //     {
  //       key: 'og:description',
  //       // name: 'og:description',
  //       property: 'og:description',
  //       content: i18n('meta.description'),
  //     },
  //     {
  //       key: 'twitter:title',
  //       // name: 'twitter:title',
  //       property: 'twitter:title',
  //       content: i18n('meta.title'),
  //     },
  //     {
  //       key: 'twitter:description',
  //       // name: 'twitter:description',
  //       property: 'twitter:description',
  //       content: i18n('meta.description'),
  //     },
  //   ]
  // },

  components: {
    landingHeader,
    landingAbout,
    landingSplash,
    landingFooter,
    // landingFaqs,
  },

  data() {
    return {
      isLoading: true,
      style_overflow: 'overflow: hidden !important;',
      view: landingHeader,
      metaTags: {
        description:
          'let’s try a new adventure to discover the world.',
        title: 'Plan and make your Trip more simple',
        url: 'https://saryahapp.com',
        image: 'images/thumbnail.png',
      },
    };
  },
  meta,

  computed: {
    ...mapGetters({
      isImagesLoaded:
        'saryahLanding/landing/isImagesLoaded',
      imageLoaded: 'saryahLanding/landing/imageLoaded',
      imagesToPreload:
        'saryahLanding/landing/imagesToPreload',
    }),
    lang() {
      return i18n.locale;
    },
  },
  methods: {
    ...mapActions({
      onImgLoad: 'saryahLanding/landing/onImgLoad',
    }),
    i18n(code, args) {
      // return i18n(code, args);
      return this.$t(code, args);
    },
  },
  watch: {
    lang() {
      document.title =
        this.i18n('app.title') +
        ' | ' +
        this.i18n('meta.title');
    },
    imageLoaded() {
      // console.log('enterd')
      if (this.isImagesLoaded) {
        setTimeout(() => {
          this.isLoading = false;
          this.style_overflow =
            'overflow: auto !important; position: unset !important;';
        }, 2000);
      }
    },
  },
};
</script>

<style lang="scss">
.home {
  background-image: url('/bg-test.jpg');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 100dvh;
  position: relative;
}
/*
.home::after{
  position: absolute;
  content: '';
  left: 0;
  top:0%;
  background: linear-gradient(0deg,#fff,transparent);
  height: 100%;
  width: 100%;

}
*/



@media (width > 640px) {
  .container {
    max-width: 640px !important;
  }
}
@media (width > 768px) {
  .container {
    max-width: 768px !important;
  }
}
@media (width > 1024px) {
  .container {
    max-width: 1024px !important;
  }
}
@media (width > 1280px) {
  .container {
    max-width: 1280px !important;
  }
}

.row {
  margin-right: 0 !important;
  margin-left: 0 !important;
}
.bg-lightblue {
  background: #36b1bf !important;
}
.bg-orange {
  background: #ffb900 !important;
}
.bg-red {
  background: #f44336 !important;
}
.q-btn--fab .q-icon,
.q-btn--fab-mini .q-icon {
  font-size: 2rem !important;
  width: 100%;
  height: 50% !important;
}
</style>
